import { DEFAULT_LOCALE, LOCALE_INFOS, } from '#pplx_generated/pplx/frontend/i18n/localeInfo.generated.js';
import { match } from '@formatjs/intl-localematcher';
export const PPLX_CHOSEN_LOCALE_COOKIE = 'pplx.chosen-locale';
export const defaultTimezone = new Intl.DateTimeFormat().resolvedOptions().timeZone;
export const supportedLocales = Object.keys(LOCALE_INFOS);
export const supportedLanguages = Object.entries(LOCALE_INFOS).map(([locale, info]) => {
    return {
        locale,
        label: info.displayName,
        characterOrder: info.characterOrder,
    };
});
/**
 * Return locale (or default locale) and whether it was matched or not
 */
export const matchLocale = (locales, candidateLocales = supportedLocales) => {
    try {
        return match(locales, candidateLocales, DEFAULT_LOCALE);
    }
    catch {
        return DEFAULT_LOCALE;
    }
};
/**
 * Load translations for the given locales
 * Note that all translations files live in the translations directory
 * so Vite doesn't complain about dynamic imports potentially including non-translation files
 * @param locales locales to load translations for
 * @returns
 */
export async function loadTranslations(locales = DEFAULT_LOCALE, localeTranslations, logger) {
    const availableLocales = localeTranslations
        ? [...new Set([DEFAULT_LOCALE, ...Object.keys(localeTranslations)])]
        : supportedLocales;
    const matchedLocale = matchLocale(Array.isArray(locales) ? locales : [locales], availableLocales);
    if (matchedLocale === DEFAULT_LOCALE) {
        return {
            matchedLocale,
            translations: {},
        };
    }
    const loader = localeTranslations?.[matchedLocale];
    try {
        const translations = (await loader?.()) ?? {};
        return {
            matchedLocale,
            translations,
        };
    }
    catch (translationLoadError) {
        logger?.error(translationLoadError, {
            translationLoadFailure: true,
            translationLocale: matchedLocale,
        });
        return {
            matchedLocale: DEFAULT_LOCALE,
            translations: {},
        };
    }
}
export function getTextDirection(locale) {
    return LOCALE_INFOS[locale]?.characterOrder ?? 'ltr';
}
//# sourceMappingURL=core.js.map